module.exports = __webpack_public_path__ + "img/probg.92b7c2dd.png";